import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Icon from '../components/Icon.jsx';
import { Info, Target, Trophy, Users } from 'lucide-react';

const AboutScreen = () => {
  return (
    <div className="section-modern">
      <Container className="fade-in py-5">
        <h1 className="text-primary mb-4"><Icon icon={Info} size={24} className="me-2 align-middle" /> About League Runner</h1>
        <p className="text-secondary lead mb-5">
          Ethan Pelton and his sons are passionate outdoor enthusiasts, and League Runner grew out
          of the life they built together around movement, community, and competition. From
          climbing to running to building spaces for others to pursue adventure, the app reflects
          the same energy that shaped their family.
        </p>
        <Row className="g-4">
          <Col md={6} lg={3}>
            <Card className="modern-card h-100">
              <Card.Body className="text-center">
                <Icon icon={Target} size={28} className="mb-3" />
                <h5 className="card-title">Outdoor Roots</h5>
                <p className="text-secondary mb-0 small">
                  Ethan and his sons have always been drawn to outdoor challenge, community, and the kind of fun that comes from doing hard things together.
                </p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} lg={3}>
            <Card className="modern-card h-100">
              <Card.Body className="text-center">
                <Icon icon={Trophy} size={28} className="mb-3" />
                <h5 className="card-title">Climbing Connection</h5>
                <p className="text-secondary mb-0 small">
                  Jayden climbed on team at Climb Nashville, a community that may feel familiar to many athletes who found their people through the sport.
                </p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} lg={3}>
            <Card className="modern-card h-100">
              <Card.Body className="text-center">
                <Icon icon={Users} size={28} className="mb-3" />
                <h5 className="card-title">Running Transformation</h5>
                <p className="text-secondary mb-0 small">
                  Running wasn't eactly "fun" at first, but joining a local running group changed everything and opened the door to bigger goals.
                </p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} lg={3}>
            <Card className="modern-card h-100">
              <Card.Body className="text-center">
                <Icon icon={Info} size={28} className="mb-3" />
                <h5 className="card-title">Built by Family</h5>
                <p className="text-secondary mb-0 small">
                  Ethan and his sons created 504 Climb in Springfield, Tennessee in 2023, carrying that same entrepreneurial and community spirit into League Runner.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Card className="modern-card mt-5">
          <Card.Body>
            <h3 className="modern-card-title mb-3">The Story Behind the App</h3>
            <p className="text-secondary mb-2">
              Ethan pretty much hated running at first. What changed was community. After joining a
              local running group, he discovered that running felt different when it was shared with
              other people who showed up, encouraged each other, and made the miles meaningful.
            </p>
            <p className="text-secondary mb-0">
              That catalyst led from 5Ks to trail races to half marathons, and eventually to
              long-distance running and an ultra in 2024. Along the way, Ethan and his sons kept
              building around the things they loved most, including climbing, running, and creating
              community through 504 Climb in Springfield, Tennessee. League Runner comes from that
              same story: a family that loves the outdoors, loves competition, and wanted to turn
              training into something people could experience together.
            </p>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default AboutScreen;
